import { createActions, createReducer } from 'reduxsauce'

const situacoes = [
    { value: '', label: 'Todas' },
    { value: 'A', label: 'Ativo' },
    { value: 'E', label: 'Encerrado' },
    { value: 'R', label: 'Rescindido' },
]
/**
 * Action types & creators
 */

export const { Types, Creators } = createActions({
    setExercicioInicialConsultaConvenio: ['exercicioInicial'],
    setExercicioFinalConsultaConvenio: ['exercicioFinal'],
    setCodigoInicialConsultaConvenio: ['codigoInicial'],
    setCodigoFinalConsultaConvenio: ['codigoFinal'],
    setAssinaturaInicialConsultaConvenio: ['assinaturaInicial'],
    setAssinaturaFinalConsultaConvenio: ['assinaturaFinal'],
    setTipoConsultaConvenio: ['tipo'],
    setAdministracaoConsultaConvenio: ['administracao'],
    setDescricaoLocalFisicoConsultaConvenio: ['descricaoLocalFisico'],
    setConvenenteConsultaConvenio: ['convenente'],
    setConcedenteConsultaConvenio: ['concedente'],
    setIntervenienteConsultaConvenio: ['interveniente'],
    setObjetoConsultaConvenio: ['objeto'],
    setSituacaoConsultaConvenio: ['situacao'],
    setExercicioLicitacaoInicialConsultaConvenio: ['exercicioLicitacaoInicial'],
    setExercicioLicitacaoFinalConsultaConvenio: ['exercicioLicitacaoFinal'],
    setNumeroLicitacaoInicialConsultaConvenio: ['numeroLicitacaoInicial'],
    setNumeroLicitacaoFinalConsultaConvenio: ['numeroLicitacaoFinal'],
    setModalidadeLicitacaoConsultaConvenio: ['modalidadeLicitacao'],
    limpaFiltroConsultaConvenio: [],
    receberFiltroConsultaConvenio: ['filtroRecebido'],
})

const INITIAL_STATE = {
    exercicioInicial: new Date().getFullYear(),
    exercicioFinal: '',
    codigoInicial: '',
    codigoFinal: '',
    assinaturaInicial: '',
    assinaturaFinal: '',
    tipo: [],
    administracao: [],
    descricaoLocalFisico: '',
    convenente: '',
    concedente: '',
    interveniente: '',
    objeto: '',
    situacao: { value: situacoes[0].value, label: situacoes[0].label },
    exercicioLicitacaoInicial: '',
    exercicioLicitacaoFinal: '',
    numeroLicitacaoInicial: '',
    numeroLicitacaoFinal: '',
    modalidadeLicitacao: [],
}

const setExercicioInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioInicial: action.exercicioInicial }
}
const setExercicioFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioFinal: action.exercicioFinal }
}
const setCodigoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, codigoInicial: action.codigoInicial }
}
const setCodigoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, codigoFinal: action.codigoFinal }
}
const setAssinaturaInicial = (state = INITIAL_STATE, action) => {
    return { ...state, assinaturaInicial: action.assinaturaInicial }
}
const setAssinaturaFinal = (state = INITIAL_STATE, action) => {
    return { ...state, assinaturaFinal: action.assinaturaFinal }
}
const setTipo = (state = INITIAL_STATE, action) => {
    return { ...state, tipo: action.tipo }
}
const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}
const setDescricaoLocalFisico = (state = INITIAL_STATE, action) => {
    return { ...state, descricaoLocalFisico: action.descricaoLocalFisico }
}
const setConvenente = (state = INITIAL_STATE, action) => {
    return { ...state, convenente: action.convenente }
}
const setConcedente = (state = INITIAL_STATE, action) => {
    return { ...state, concedente: action.concedente }
}
const setInterveniente = (state = INITIAL_STATE, action) => {
    return { ...state, interveniente: action.interveniente }
}
const setObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: action.objeto }
}
const setSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: action.situacao }
}
const setExercicioLicitacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacaoInicial: action.exercicioLicitacaoInicial }
}
const setExercicioLicitacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacaoFinal: action.exercicioLicitacaoFinal }
}
const setNumeroLicitacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacaoInicial: action.numeroLicitacaoInicial }
}
const setNumeroLicitacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacaoFinal: action.numeroLicitacaoFinal }
}
const setModalidadeLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, modalidadeLicitacao: action.modalidadeLicitacao }
}
const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_INICIAL_CONSULTA_CONVENIO]: setExercicioInicial,
    [Types.SET_EXERCICIO_FINAL_CONSULTA_CONVENIO]: setExercicioFinal,
    [Types.SET_CODIGO_INICIAL_CONSULTA_CONVENIO]: setCodigoInicial,
    [Types.SET_CODIGO_FINAL_CONSULTA_CONVENIO]: setCodigoFinal,
    [Types.SET_ASSINATURA_INICIAL_CONSULTA_CONVENIO]: setAssinaturaInicial,
    [Types.SET_ASSINATURA_FINAL_CONSULTA_CONVENIO]: setAssinaturaFinal,
    [Types.SET_TIPO_CONSULTA_CONVENIO]: setTipo,
    [Types.SET_ADMINISTRACAO_CONSULTA_CONVENIO]: setAdministracao,
    [Types.SET_DESCRICAO_LOCAL_FISICO_CONSULTA_CONVENIO]: setDescricaoLocalFisico,
    [Types.SET_CONVENENTE_CONSULTA_CONVENIO]: setConvenente,
    [Types.SET_CONCEDENTE_CONSULTA_CONVENIO]: setConcedente,
    [Types.SET_INTERVENIENTE_CONSULTA_CONVENIO]: setInterveniente,
    [Types.SET_OBJETO_CONSULTA_CONVENIO]: setObjeto,
    [Types.SET_SITUACAO_CONSULTA_CONVENIO]: setSituacao,
    [Types.SET_EXERCICIO_LICITACAO_INICIAL_CONSULTA_CONVENIO]: setExercicioLicitacaoInicial,
    [Types.SET_EXERCICIO_LICITACAO_FINAL_CONSULTA_CONVENIO]: setExercicioLicitacaoFinal,
    [Types.SET_NUMERO_LICITACAO_INICIAL_CONSULTA_CONVENIO]: setNumeroLicitacaoInicial,
    [Types.SET_NUMERO_LICITACAO_FINAL_CONSULTA_CONVENIO]: setNumeroLicitacaoFinal,
    [Types.SET_MODALIDADE_LICITACAO_CONSULTA_CONVENIO]: setModalidadeLicitacao,
    [Types.LIMPA_FILTRO_CONSULTA_CONVENIO]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_CONVENIO]: receberFiltro,
})
